angular.module('mercury.modules.reports.reconciliations')
.controller('ReportsReconciliationTendersCtrl', ["$filter", "$q", "PosTenders", "PosTips", "reporttime", "$scope", "title", function($filter, $q, PosTenders, PosTips, reporttime, $scope, title) {
  title.set('Tenders Report');

  $scope.tenderCols = [
    {label: 'Tender', type: 'string', key: 'tenderName'},
    {label: 'Amount', type: 'number', key: 'tenderAmount', filter: 'currency'}
  ];

  $scope.loading = $q.all({
    tenders: PosTenders.get(reporttime.start(), reporttime.end()),
    tenderSurcharges: PosTenders.getSurcharges(reporttime.start(), reporttime.end()),
    tips: PosTips.getByInterval(reporttime.start(), reporttime.end())
  });

  $scope.showTotalsTable = reporttime.reportType() !== 'day';

  $scope.loading.then(function(results) {

    $scope.tenders = results.tenders;
    $scope.tenderSurcharges = results.tenderSurcharges;
    $scope.tips = results.tips;

    $scope.times = [];
    for (var iter = moment(reporttime.start()); iter.isBefore(reporttime.end()); iter.add(1, 'day')) {
      var dayTenders = $filter('filter')($scope.tenders, {startTime: iter.format()});
      var dayTenderSurcharges = $filter('filter')($scope.tenderSurcharges, {startTime: iter.format()});
      var dayTips = $filter('filter')($scope.tips, {startTime: iter.format()});

      var tenderSurchargeAmount = $filter('sumof')(dayTenderSurcharges, 'tenderSurchargeAmount');
      var tipsAmount = $filter('sumof')(dayTips, 'amount');

      var day = {
        startTime: iter.format(),
        tenders: dayTenders,
        tenderSurchargeAmount: tenderSurchargeAmount,
        tipsAmount: tipsAmount,
        totalTendered: $filter('sumof')(dayTenders, 'tenderAmount') + tenderSurchargeAmount + tipsAmount
      };

      $scope.times.push(day);
    }

    var tenderTotals = {};
    $scope.totalTenderAmount = 0;

    // Calculate totals for each tender type, pushing an entry into the object
    // that ultimately drives the chart/table.
    angular.forEach($scope.tenders, function(tender) {
      if (tenderTotals[tender.tenderPosIdentifier]) {
        tenderTotals[tender.tenderPosIdentifier].tenderAmount += tender.tenderAmount;
      } else {
        tenderTotals[tender.tenderPosIdentifier] = {
          tenderName: tender.tenderName,
          tenderAmount: tender.tenderAmount
        };
      }
      $scope.totalTenderAmount += tender.tenderAmount;
    });

    // Add a tender surcharges entry
    tenderTotals.tenderSurcharges = {
      tenderName: 'Tender Surcharges',
      tenderAmount: $filter('sumof')($scope.tenderSurcharges, 'tenderSurchargeAmount')
    };
    $scope.totalTenderAmount += tenderTotals.tenderSurcharges.tenderAmount;

    // Add a tips total entry
    tenderTotals.tips = {
      tenderName: 'Tips',
      tenderAmount: $filter('sumof')($scope.tips, 'amount')
    };
    $scope.totalTenderAmount += tenderTotals.tips.tenderAmount;

    $scope.tenderTotals = Object.values(tenderTotals);
  });
}]);
